import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  return (
    <div className="min-h-screen pt-32 pb-20 px-4 bg-gray-50" data-testid="payment-cancel-page">
      <div className="max-w-xl mx-auto bg-white rounded-3xl p-8 sm:p-12 border border-gray-100 text-center">
        <XCircle className="w-16 h-16 text-amber-500 mx-auto mb-6" />
        <h1 className="text-3xl font-bold text-gray-900 mb-3">Payment cancelled</h1>
        <p className="text-gray-600 mb-8">No payment was taken. Your items are still in your cart whenever you're ready.</p>
        <div className="flex flex-wrap gap-3 justify-center">
          <Button asChild className="bg-pink-500 hover:bg-pink-600 text-white rounded-full"><Link to="/checkout" data-testid="cancel-try-again">Try again</Link></Button>
          <Button asChild variant="outline" className="rounded-full"><Link to="/cart" data-testid="cancel-back-to-cart">Back to cart</Link></Button>
        </div>
      </div>
    </div>
  );
}
